import MapRender from "./mapRender";

export default MapRender;